import { useEffect, useState } from "react";
import styled from "styled-components";
import { IMAGES } from "./constants/images";
import { BACKEND_URL } from "./constants/env";

export default function AuthGate({ children }) {
  const [ok, setOk] = useState(false);
  const [loading, setLoading] = useState(true);
  const [pwd, setPwd] = useState("");
  const [show, setShow] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const r = await fetch(`${BACKEND_URL}/api/auth/me`, { credentials: "include" });
        setOk(r.ok);
      } catch {
        setOk(false);
      }
      setLoading(false);
    })();
  }, []);

  const login = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      const r = await fetch(`${BACKEND_URL}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ password: pwd }),
      });
      if (!r.ok) {
        const data = await r.json().catch(() => ({}));
        setErr(data.error || "Login failed");
        setOk(false);
      } else {
        setOk(true);
      }
    } catch {
      setErr("Network error");
    }
  };

  const logout = async () => {
    try {
      await fetch(`${BACKEND_URL}/api/auth/logout`, { method: "POST", credentials: "include" });
    } catch {}
    setOk(false);
    setPwd("");
  };

  if (loading) return <span>Loading…</span>;
  if (ok)
    return (
      <>
        {children}
        <LogoutButton onClick={logout} title="Logout">
          <img src={IMAGES.EXIT} alt="Exit" />
        </LogoutButton>
      </>
    );

  return (
    <FullScreen>
      <Card onSubmit={login}>
        <h2>Authorization</h2>
        <label>Password</label>
        <PwdRow>
          <input
            type={show ? "text" : "password"}
            value={pwd}
            onChange={(e) => setPwd(e.target.value)}
            placeholder="Enter your password"
            autoFocus
            onKeyDown={(e) => e.key === "Enter" && login(e)}
          />
          <Toggle type="button" onClick={() => setShow((s) => !s)}>
            {show ? "Hide" : "Show"}
          </Toggle>
        </PwdRow>
        {err && <ErrorText>{err}</ErrorText>}
        {/* <Remember>
          <input
            id="remember"
            type="checkbox"
            checked={remember}
            onChange={(e) => setRemember(e.target.checked)}
          />
          <label htmlFor="remember">Remember me</label>
        </Remember> */}
        <Submit type="submit">Log in</Submit>
      </Card>
    </FullScreen>
  );
}

const FullScreen = styled.div`
  position: fixed;
  inset: 0;
  display: grid;
  place-items: center;
  background: linear-gradient(135deg, #eef1f7, #f7f9ff);
`;

const Card = styled.form`
  width: 320px;
  padding: 20px 22px;
  background: #fff;
  border: 1px solid #e6eaf2;
  border-radius: 12px;
  box-shadow: 0 6px 24px rgba(16, 24, 40, 0.08);
  display: grid;
  gap: 10px;

  h2 {
    margin: 0 0 6px;
    font-size: 20px;
  }
  label {
    font-size: 13px;
    color: #555;
  }
  input[type="password"],
  input[type="text"] {
    width: 100%;
    height: 36px;
    padding: 0 10px;
    border: 1px solid #cfd6e4;
    border-radius: 8px;
    outline: none;
  }
  input:focus {
    border-color: #6aa2ff;
    box-shadow: 0 0 0 3px rgba(106, 162, 255, 0.2);
  }
`;

const PwdRow = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 8px;
  align-items: center;
`;

const Toggle = styled.button`
  height: 36px;
  min-width: 55px;
  padding: 0 10px;
  border-radius: 8px;
  border: 1px solid #cfd6e4;
  background: #f7f8fb;
  cursor: pointer;
`;

// const Remember = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 8px;
//   margin-top: 2px;
//   label {
//     cursor: pointer;
//   }
// `;

const ErrorText = styled.div`
  color: #c62828;
  font-size: 13px;
  margin-top: 4px;
`;

const Submit = styled.button`
  height: 38px;
  margin-top: 4px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  background: #007bff;
  color: #fff;
  font-weight: 600;
  &:hover {
    background: #268fff;
  }
`;

const LogoutButton = styled.button`
  position: absolute;
  right: 20px;
  bottom: 47px;
  background-color: white;
  height: 34px;
  width: 34px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #ececec;
  }
`;
